import React from 'react';
import { iconRegistry, type IconName } from '@/lib/icons';

export interface IconProps extends Omit<React.SVGAttributes<SVGSVGElement>, 'name'> {
    /** Semantic icon key from the shared registry (`src/lib/icons.ts`). */
    name: IconName;
}

/**
 * Renders a self-hosted `lucide-react` SVG icon for the given semantic
 * `name`, replacing the CDN-loaded Font Awesome icon font. Always carries an
 * `icon` class so `width`/`height: 1em` (see `App.css`) lets the surrounding
 * `font-size` keep controlling icon size, exactly like the old icon font did.
 * Decorative by default (`aria-hidden`); pass `aria-label`/`role="img"` for a
 * meaningful, standalone icon.
 */
const Icon: React.FC<IconProps> = ({ name, className = '', ...rest }) => {
    const IconComponent = iconRegistry[name];

    return (
        <IconComponent
            aria-hidden={rest['aria-label'] ? undefined : true}
            className={['icon', className].filter(Boolean).join(' ')}
            {...rest}
        />
    );
};

export default Icon;
